import { AnimatedBanner } from "@faire/deprecated-retailer-visitor-shared/components/AnimatedBanner/AnimatedBanner";
import { useFaireDirectFirstOrderIncentiveBanners } from "@faire/deprecated-retailer-visitor-shared/components/Notifications/Components/FaireDirectIncentivesBanner/__internal__/useFaireDirectFirstOrderIncentiveBanners";
import { FaireDirectMarketplaceIncentiveBanner } from "@faire/deprecated-retailer-visitor-shared/components/Notifications/Components/FaireDirectIncentivesBanner/FaireDirectMarketplaceIncentiveBanner/FaireDirectMarketplaceIncentiveBanner";
import { useFaireDirectMarketplaceIncentive } from "@faire/deprecated-retailer-visitor-shared/hooks/FaireDirect/useFaireDirectMarketplaceIncentive/useFaireDirectMarketplaceIncentive";
import { Decorative } from "@faire/design-tokens";
import { getSpacing } from "@faire/web/slate/spacing";
import React from "react";
import styled from "styled-components";

export const FaireDirectIncentivesBanner: React.FC = () => {
  const { hasIncentive: hasMarketplaceIncentive } =
    useFaireDirectMarketplaceIncentive();
  const FIRST_ORDER_INCENTIVE_BANNERS =
    useFaireDirectFirstOrderIncentiveBanners();

  if (hasMarketplaceIncentive) {
    return (
      <BannerWrapper>
        <FaireDirectMarketplaceIncentiveBanner />
      </BannerWrapper>
    );
  }

  return (
    <StyledAnimatedBanner
      banners={Object.values(FIRST_ORDER_INCENTIVE_BANNERS)}
      bannerNames={Object.keys(FIRST_ORDER_INCENTIVE_BANNERS)}
    />
  );
};

const StyledAnimatedBanner = styled(AnimatedBanner)`
  background-color: ${Decorative.tint.neutral};
`;

const BannerWrapper = styled.div`
  padding: ${getSpacing("1x")};
  background-color: ${Decorative.tint.neutral};
`;
